
(($) => {
    $('.slides').each(function () {
        const slide = $(this);
        const slideItems = slide.find('.slide-item');
        const slideWindow = slide.find('.slides-content');
        const slideItemsWrapper = slide.find('.slides-content-inner');
        const slideControls = slide.find('.slides-control > button');
        const prev = slide.find('.slides-prev');
        const next = slide.find('.slides-next');
        let currentIndex = 0;

        const slideTo = (index) => {

            if (index < 0) {
                index = 0;
            } else if (index >= slideItems.length) {
                index = slideItems.length - 1;
            }

            currentIndex = index;

            slideControls.removeClass('active');
            $(slideControls[index]).addClass('active');

            const targetItem = $(slideItems[index]);

            const targetItemLeftPosition = targetItem.position().left;

            let wrapperLeftPosition = 0;

            if (index < slideItems.length -1) {
                // If not last item
                wrapperLeftPosition = targetItemLeftPosition - (slideWindow.innerWidth() / 2) + (targetItem.innerWidth() / 2) - 24;
                if (wrapperLeftPosition < 0) {
                    wrapperLeftPosition = 0;
                }
            } else {
                // Last Item
                if (index === slideItems.length -1) {
                    wrapperLeftPosition = targetItemLeftPosition - slideWindow.innerWidth() + targetItem.innerWidth() - 24 * 2;
                }
            }

            slideItems.removeClass('active');

            slideItemsWrapper.css({left: `-${wrapperLeftPosition}px`});

            targetItem.addClass('active');
        }

        slideControls.on('click', (e) => {
            e.preventDefault();

            const control = $(e.target);
            slideTo(control.index());
        });

        prev.on('click', (e) => {
            e.preventDefault();

            slideTo(currentIndex - 1);
        });

        next.on('click', (e) => {
            e.preventDefault();

            slideTo(currentIndex + 1);
        });
    });
})(jQuery);
